import { useEffect, useState } from 'react';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { ListingSearchCriteria } from '@components/layouts/Truva/ListingSearchDeprecated/utils';
import actions from '@store/actions/listingSearchPage';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SpaceCondition, ListingSearchFilterTypes } from '@root/types';
import Checkbox from '@components/shared/forms/RawCheckbox';
import useHighlightedClick from '../useHighlightedClick';
import s from '../Filters.module.less';

export const conditions: Array<{ label: string; value: SpaceCondition; translationKey: string }> = [
  {
    label: 'Pre-built',
    value: 'pre-built',
    translationKey: 'filters:spaceCondition:preBuilt',
  },
  {
    label: '2nd generation',
    value: '2nd generation',
    translationKey: 'filters:spaceCondition:secondGeneration',
  },
  {
    label: 'Pre-existing',
    value: 'pre-existing',
    translationKey: 'filters:spaceCondition:preExisting',
  },
  {
    label: 'Turnkey',
    value: 'turnkey',
    translationKey: 'filters:spaceCondition:turnkey',
  },
  {
    label: 'White box',
    value: 'white box',
    translationKey: 'filters:spaceCondition:whiteBox',
  },
  {
    label: 'Core and shell',
    value: 'core and shell',
    translationKey: 'filters:spaceCondition:coreAndShell',
  },
  {
    label: 'Raw',
    value: 'raw',
    translationKey: 'filters:spaceCondition:raw',
  },
  {
    label: 'Challenged',
    value: 'challenged',
    translationKey: 'filters:spaceCondition:challenged',
  },
  {
    label: 'Under construction',
    value: 'under construction',
    translationKey: 'filters:spaceCondition:underConstruction',
  },
];

type Props = {
  criteria: ListingSearchCriteria;
  onChange: (criteria: ListingSearchCriteria) => void;
  type: ListingSearchFilterTypes;
};

const SpaceConditionFilters = ({ criteria, onChange, type }: Props) => {
  const [selectedConditions, setSelectedConditions] = useState(criteria.spaceConditions());
  useEffect(() => {
    setSelectedConditions(criteria.spaceConditions());
  }, [criteria]);

  const { t } = useTranslation();

  const { setHighlighted, isHighlighted } = useHighlightedClick();

  const dispatch = useDispatch();

  const toggleCheckbox = (value: SpaceCondition) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const nowChecked = e.target.checked;
    setHighlighted(value);
    if (nowChecked) {
      setSelectedConditions([...selectedConditions, value]);
      criteria.addValue('spaceCondition', value);
    } else {
      setSelectedConditions(selectedConditions.filter(condition => condition !== value));
      criteria.removeValue('spaceCondition', value);
    }

    dispatch(actions.spaceConditionFilterChanged(criteria.spaceConditions()));
    onChange(criteria);
  };

  return (
    <>
      <ul className={s.filterList}>
        {conditions.map(({ label, value, translationKey }) => (
          <li
            data-testid={`container-${value}`}
            key={label}
            className={classnames(isHighlighted(value) && s.highlighted)}
          >
            <Checkbox
              className={s.checkbox}
              checked={selectedConditions.includes(value)}
              name={`${label}-${type}`}
              onChange={toggleCheckbox(value)}
            >
              {t(translationKey)}
            </Checkbox>
          </li>
        ))}
      </ul>
    </>
  );
};

export default SpaceConditionFilters;
